export default () => {
  const hostConfig = {
    test: ["test.platform.9five.ai"],
    uat: ["test.platform.9five.ai"],
    prod: ["platform.9five.ai"],
  };

  const host = document.domain.toLowerCase();
  let env = "dev";

  Object.keys(hostConfig).some((key) => {
    if (hostConfig[key].includes(host)) {
      env = key;
      return true;
    }
    return false;
  });

  return env;
};
